import { provideHttpClient } from "@angular/common/http";
import {
  ApplicationConfig,
  ErrorHandler,
  provideAppInitializer,
} from "@angular/core";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { DialogService } from "src/prime/dynamicdialog/dialogservice";
import { authProviders } from "src/standard/auth/auth";
import { withStandardInteceptors } from "src/standard/interceptors/withStandardInterceptors";
import { StandardLogService } from "src/standard/logging/logging";
import { GlobalErrorHandler } from "src/standard/pages/error-pages/global-error-handler/global-error-handler.component";
import { init } from "src/standard/pages/init";
import { routerProviders } from "src/standard/pages/router-providers";

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideAppInitializer(() => {
      const initializerFn = init();
      // inject(HttpClient),
      // inject(SecurityService),
      // inject(StandardLogService),
      // inject(ServerSidePublicConfigDataService),
      return initializerFn();
    }),
    provideAnimationsAsync(),
    ...authProviders,
    provideHttpClient(withStandardInteceptors()),
    routerProviders,
    { provide: StandardLogService },
    { provide: DialogService }, // dramatically simplify code to pull the dialog service in immediately, even if it makes the main critical bundle a bit larger
  ],
};
